import { render, staticRenderFns } from "./ModificarHorario.vue?vue&type=template&id=5849fbc6&scoped=true&"
import script from "./ModificarHorario.vue?vue&type=script&lang=js&"
export * from "./ModificarHorario.vue?vue&type=script&lang=js&"
import style0 from "./ModificarHorario.vue?vue&type=style&index=0&id=5849fbc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849fbc6",
  null
  
)

export default component.exports